<template>
  <form
    ref="form"
    data-gg-dynamic-form
    :class="formClass"
    @submit="handleSubmit"
  >
    <slot />
  </form>
</template>
<script>
import { logApiAccess, logForcedLogout } from '../utils/audit-logger'

export default {
  name: 'DynamicForm',
  props: {
    apiUrl: {
      type: String,
      required: true
    },
    method: {
      type: String,
      default: 'POST'
    },
    formClass: {
      type: String,
      default: ''
    }
  },
  methods: {
    async handleSubmit (ev) {
      ev.preventDefault()
      const form = this.$refs.form
      const formName =
        form.getAttribute('name') ||
        form.getAttribute('id') ||
        form.getAttribute('aria-label') ||
        'dynamic-form'

      const formData = new FormData(form)
      const siteUri = window.location.pathname.slice(1).split("/")[0];
      const token = window.localStorage.getItem(`gg-${siteUri}-token`)
      let response
      try {
        response = await fetch(this.apiUrl, {
          method: this.method,
          headers: {
            'Authorization': `Bearer ${token}`
          },
          body: formData
        })
      } catch {
        logApiAccess(this.method, this.apiUrl, 'failed', null)
        return
      }
      if (response.status === 401) {
        logApiAccess(this.method, this.apiUrl, 'failed', 401)
        logForcedLogout('token_expired_401')
        window.localStorage.removeItem(`gg-${siteUri}-token`)
        if (window.localStorage.getItem('login_required') === 'true') {
          window.location.reload()
        }
        return
      }
      logApiAccess(
        this.method,
        this.apiUrl,
        response.ok ? 'success' : 'failed',
        response.status,
        { formLabel: formName.slice(0, 100) },
      )
      const res = await response.json()
      this.$emit('updated', res)
    }
  }
}
</script>